import React from 'react';
import { PROVIDER_NOT_CONFIGURED_MESSAGE } from '../../services/CommunicationsService';

/** Shown wherever sending is switched off because WhatsApp is not set up. */
const ProviderNotice: React.FC<{ className?: string }> = ({ className = '' }) => (
  <p className={`communications-provider-notice ${className}`.trim()} role="status">
    {PROVIDER_NOT_CONFIGURED_MESSAGE}
  </p>
);

export default ProviderNotice;
